/**
 * "How did you find Heavenly Hydration?"
 *
 *   "it should be the first question. How did you find Heavenly Hydration:
 *    Google, FB, Instagram, Event, Word Of Mouth, Another Client (Referral
 *    Program)."
 *
 * The same six answers her intake form offers, so the desk typing a client in
 * by hand records the same words the client would have picked themselves and
 * the Advertising page can add them up. (The list lives on her intake form in
 * the database; this mirrors it for the places staff answer it on a client's
 * behalf.)
 */
export const REFERRAL_SOURCES = [
  "Google",
  "Facebook",
  "Instagram",
  "Event",
  "Word Of Mouth",
  "Another Client (Referral Program)",
] as const;
